import styled from 'styled-components'
import { Table } from 'antd'
import { COLORS } from 'theme'

export const StyledTable = styled(Table)`
  padding: ${props => (props.padding ? props.padding : '0px')};
  .ant-table-container table > thead > tr:first-child th:first-child,
  .ant-table-container table > tbody > tr td:first-child {
    padding-left: 25px;
  }
  .ant-table-container table > thead > tr:first-child th:last-child,
  .ant-table-container table > tbody > tr td:last-child {
    padding-right: 25px;
  }
  .ant-table-thead {
    height: 60px;
  }

  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: #fff !important;
  }
  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    content: none;
  }
  tr {
    th {
      background: ${COLORS.PRIMARY_GREY_T_98};
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: ${COLORS.GREY_T_30};

      ::before {
        height: 0px;
      }
    }
  }

  .ant-table-pagination.ant-pagination {
    justify-content: center;
  }
`
